import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../utils/UsageTracker';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCurrentLearningInterest, useWizardCategoriesMap } from '../../features/wizard/wizardQueries';
import { HUBSPOT_SOFTWARE_INDEX } from '../../features/wizard/wizardTypes';
import { WizardList } from './WizardList';
import { jsx as _jsx } from "react/jsx-runtime";
const WizardTools = ({
  onOptionSelect
}) => {
  const {
    selectedToolsGroup
  } = useCurrentLearningInterest();
  const {
    wizardCategoryMap,
    isLoading
  } = useWizardCategoriesMap();
  const trackToolGroupClick = toolsGroup => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-tools-group',
      categoryClicked: toolsGroup
    });
  };
  const trackToolClick = tool => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-tool',
      categoryClicked: tool
    });
  };
  const selectTool = tool => {
    onOptionSelect(tool);
  };
  const selectToolGroup = group => {
    onOptionSelect(group);
  };
  const renderToolList = () => {
    const toolsMap = wizardCategoryMap[HUBSPOT_SOFTWARE_INDEX];
    return /*#__PURE__*/_jsx(WizardList, {
      children: !selectedToolsGroup ? Object.keys(toolsMap).map(toolGroup => /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        onClick: () => trackToolGroupClick(toolGroup),
        onSelectedChange: () => {
          selectToolGroup(toolGroup);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.filtersGroups.${toolGroup}`
        })
      }, toolGroup)) : Object.values(toolsMap[selectedToolsGroup]).map(tool => /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        onClick: () => trackToolClick(tool),
        onSelectedChange: () => {
          selectTool(tool);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.tools.${tool}`
        })
      }, tool))
    });
  };
  return !isLoading ? renderToolList() : /*#__PURE__*/_jsx(LoadingSpinner, {
    size: 'sm'
  });
};
export default WizardTools;